import { CrudFilters, IResourceComponentsProps, usePermissions, useShow } from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
  Modal,
  Show,
  Typography,
  CreateButton,
  Input,
  Form,
  Icons,
  Button,
  Row,
  Col,
  FilterDropdown,
  Select,
  useSelect,
} from "@pankod/refine-antd";
import { IEmployee, IOrganizationalUnit } from "interfaces";
import { useState } from "react";
import { PermissionsConstants } from "constants/permissions";

const { Title, Text } = Typography;

export const EmployeeList: React.FC<IResourceComponentsProps> = () => {

  const { data: permissionsData } = usePermissions();

  const { tableProps, sorter, searchFormProps } = useTable<IEmployee>({
    initialSorter: [
      {
        field: "id",
        order: "asc",
      },
    ],
    initialPageSize: 15,
    onSearch: (params: any) => {
      const filters: CrudFilters = [];
      const { q } = params;
      filters.push(
          {
              field: 'name_like',
              operator: 'eq',
              value: q,
          },
      );
      return filters;
    },
  });

  const { selectProps: uoSelectProps } = useSelect<IOrganizationalUnit>({
    resource: "organizational-units",
    optionLabel: "name",
    optionValue: "id",
  });

  const [visible, setVisible] = useState(false);
  const { queryResult, showId, setShowId } = useShow<IEmployee>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <>
      <List
        headerButtons={() => <CreateButton type="primary">Nuevo Empleado</CreateButton> }
      >
        <Form layout="vertical" {...searchFormProps}>
          <Row gutter={[20, 0]}>
            <Col span={12}>
              <Form.Item name="q">
                  <Input
                      placeholder="Nombre"
                      prefix={<Icons.SearchOutlined />}
                  />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                  <Button htmlType="submit" type="primary">
                      Buscar
                  </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table {...tableProps} rowKey="id">
          <Table.Column
            dataIndex="id"
            key="id"
            title="No. Empleado"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("id", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="name"
            key="name"
            title="Nombre"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("name", sorter)}
            sorter
          />
          <Table.Column
            dataIndex="type"
            key="type"
            title="Tipo"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("type", sorter)}
            sorter
            filterDropdown={(props) => (
              <FilterDropdown {...props}>
                  <Select
                      style={{ minWidth: 200 }}
                      placeholder="Tipo"
                      options={[
                        {
                          label: "Administrativo",
                          value: "ADMINISTRATIVO",
                        },
                        {
                          label: "Acádemico",
                          value: "ACADÉMICO",
                        },
                        {
                          label: "Confianza",
                          value: "CONFIANZA",
                        },
                        {
                          label: "Jubilado",
                          value: "JUBILADO",
                        }
                      ]}
                  />
              </FilterDropdown>
            )}
          />
          <Table.Column
            dataIndex="phone"
            key="phone"
            title="Celular"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("phone", sorter)}
            sorter
          />
          <Table.Column
            dataIndex={["organizational_unit", "name"]}
            key="id_organizational_unit"
            title="UO/UA"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("id_organizational_unit", sorter)}
            sorter
            filterDropdown={(props) => (
              <FilterDropdown
                {...props}
                mapValue={(value) => value.toString()}
              >
                  <Select
                      style={{ minWidth: 300 }}
                      placeholder="Unidad Academica"
                      {...uoSelectProps}
                  />
              </FilterDropdown>
            )}
          />
          <Table.Column<IEmployee>
            title="Acciones"
            dataIndex="actions"
            render={(_, record) => (
              <Space>
                { (permissionsData?.includes(PermissionsConstants.EMPLOYEES_GOD) || record.id >= 90000) && (
                  <EditButton hideText size="small" recordItemId={record.id} />
                )}
                <ShowButton hideText size="small" recordItemId={record.id}  
                  onClick={() => {
                    setShowId(record.id);
                    setVisible(true);
                }} />
                { (permissionsData?.includes(PermissionsConstants.EMPLOYEES_GOD) || record.id >= 90000) && (
                  <DeleteButton hideText size="small" recordItemId={record.id} />
                )}
              </Space>
            )}
          />
        </Table>
      </List>
      <Modal visible={visible} onCancel={() => setVisible(false)} onOk={() => setVisible(false)}>
        <Show 
          isLoading={isLoading}
          recordItemId={showId}
          headerProps={{
            title: 'Empleado'
          }}
          headerButtons={<></>}
        >
          <Title level={5}>ID</Title>
          <Text>{record?.id}</Text>
          <Title level={5}>Nombre</Title>
          <Text>{record?.name}</Text>
          <Title level={5}>Tipo</Title>
          <Text>{record?.type}</Text>
          <Title level={5}>UO/UA</Title>
          <Text>{record?.organizational_unit?.name}</Text>
        </Show>
      </Modal>
    </>
  );
};
